/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsPermissionsListItem
 */
export interface MelcoModelsPermissionsListItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsPermissionsListItem
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsPermissionsListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsPermissionsListItem
     */
    parent_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsPermissionsListItem
     */
    filter_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsPermissionsListItem
     */
    filter_list?: string | null;
}

export function MelcoModelsPermissionsListItemFromJSON(json: any): MelcoModelsPermissionsListItem {
    return MelcoModelsPermissionsListItemFromJSONTyped(json, false);
}

export function MelcoModelsPermissionsListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsPermissionsListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'parent_code': !exists(json, 'parent_code') ? undefined : json['parent_code'],
        'filter_type': !exists(json, 'filter_type') ? undefined : json['filter_type'],
        'filter_list': !exists(json, 'filter_list') ? undefined : json['filter_list'],
    };
}

export function MelcoModelsPermissionsListItemToJSON(value?: MelcoModelsPermissionsListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'parent_code': value.parent_code,
        'filter_type': value.filter_type,
        'filter_list': value.filter_list,
    };
}


